<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/color
ib-dialog(v-model="show", autoclose, width="1356px", height="100%",class="comp-dialog")
    template(slot="default")
        div(class="iframe-headers",  v-if="showQuoteDetails === 'new'")
            div(class="iframe-header-info start-16")
                iframe(
                    :src="iframeURL",
                    style="border:none",
                    width="100%",
                    height="100%",
                    title="Contract Details",
                    id="contractFrame",
                    v-if="reloadIframe"
                )
        div
            span(class="icon-close", @click="close")
                +icon-basic-cancel_filled
    div(class="headers", v-if="showQuoteDetails === 'old'")
            div(class="header-info start-16")
                div(class="product-name")
                    h1(class="") {{ results }}
                div(class="disclose")
                    h6(class="") {{ $t('disclosure') }} 
                        span(@click="openDisclosure", class="disclose-link") https://ibkr.info/article/2966
            div(class="contract-details")
                div(class="quote-details")
                    div(class="quote-details-headers")
                        div(class="quote-symprice")
                            h3(class="symprice") {{ marketData[7219] }}
                                span(class="quote-details-data fg70") {{ assetName }}
                                span(class="quote-details-data fg50") {{ listingExchange }}
                            //h1(class="price") {{ marketData[31] }}
                                span(class="fg-positive quote-details-data") {{ marketData[82] }}
                                span(class="fg-positive quote-details-data") {{ marketData[83] }}
                        //div(class="quote-askbid")
                            div
                                h6(class="fg70") {{ $t('ask') }}   
                                    span(class="fg-negative") {{ marketData[86] }}
                                h6(class="fg70") {{ $t('bid') }}   
                                    span(class="fg-accent") {{ marketData[84] }}
                            div(class="ask-bid-data")
                                h6(class="fg-negative") x {{ marketData[85] }} 
                                h6(class="fg-accent") x {{ marketData[88] }}
                    div(class="quote-details-widgets")
                        //div(class="marketdata flex-flex")
                            div(class="marketadata-col start-16 end-16")
                                b {{ $t('today') }}
                                p {{ $t('open') }}
                                    span(class="values", v-if="marketData[7295]") {{ marketData[7295] }}
                                    span(class="values", v-else-if="!marketData[7295]") -
                                p {{ $t('close') }}
                                    span(class="values", v-if="marketData[7296]") {{ marketData[7296] }}
                                    span(class="values", v-else-if="!marketData[7296]") -
                            div(class="marketadata-col start-16 end-16")
                                b {{ $t('today') }}
                                p {{ $t('high') }}
                                    span(class="values", v-if="marketData[70]") {{ marketData[70] }}
                                    span(class="values", v-else-if="!marketData[70]") -
                                p {{ $t('low') }}
                                    span(class="values", v-if="marketData[71]") {{ marketData[71] }}
                                    span(class="values", v-else-if="!marketData[71]") -
                            div(class="marketadata-col start-16 end-16")
                                b {{ $t('fiftytwoweek') }}
                                p {{ $t('high') }}
                                    span(class="values", v-if="marketData[7293]") {{ marketData[7293] }}
                                    span(class="values", v-else-if="!marketData[7293]") -
                                p {{ $t('low') }}
                                    span(class="values", v-if="marketData[7294]") {{ marketData[7294] }}
                                    span(class="values", v-else-if="!marketData[7294]") -
                            div(class="marketadata-col start-16 end-16")
                                b {{ $t('volume') }}
                                p {{ $t('today') }}
                                    span(class="values", v-if="marketData[87]") {{ marketData[87] }}
                                    span(class="values", v-else-if="!marketData[87]") -
                                p {{ $t('average') }}
                                    span(class="values", v-if="marketData[7282]") {{ marketData[7282] }}
                                    span(class="values", v-else-if="!marketData[7282]") -
                            div(class="md-col start-16 end-16")
                                b {{ $t('volatility') }}
                                p {{ $t('hist') }}
                                    span(class="values", v-if="marketData[7284]") {{ marketData[7284] }}
                                    span(class="values", v-else-if="!marketData[7284]") -
                                p {{ $t('impl') }}
                                    span(class="values", v-if="marketData[7283]") {{ marketData[7283] }}
                                    span(class="values", v-else-if="!marketData[7283]") -
                        div(class="summary")
                            div(v-if="isSummary && this.type != 'ETF'")
                                ib-progress-circular(v-if="summary.length === 0", width="40px", height="40px", class="alignment")
                                span(v-if="summary") {{ summary }}
                            div(v-else)
                                span(class="warnings")
                                    +icon-color-warning
                                span(class="warn-message") There is no summary data available for the requested ticker.
                        div(class="fundamentals flex-flex")
                            div(class="fundamentals-details start-16 end-16")
                                li {{ $t('marketcap') }}
                                    span(class="values", v-if="ratios.marketcap") {{ ratios.marketcap }}
                                    span(class="values", v-else-if="!ratios.marketcap") -
                                li {{ $t('pe') }}
                                    span(class="values", v-if="ratios.pe") {{ ratios.pe }}
                                    span(class="values", v-else-if="!ratios.pe") -
                                li {{ $t('rev_shares') }} 
                                    span(class="values", v-if="ratios.ttmrevps") {{ ratios.ttmrevps }}
                                    span(class="values", v-else-if="!ratios.ttmrevps") -
                                li {{ $t('price_book') }}
                                    span(class="values", v-if="ratios.pricebook") {{ ratios.pricebook }}
                                    span(class="values", v-else-if="!ratios.pricebook") -
                                li {{ $t('price_tangible_book') }} 
                                    span(class="values", v-if="ratios.pricetangiblebook") {{ ratios.pricetangiblebook }}
                                    span(class="values", v-else-if="!ratios.pricetangiblebook") -
                                li {{ $t('eps_growth') }} 
                                    span(class="values", v-if="ratios.epsgrowth") {{ ratios.epsgrowth }}
                                    span(class="values", v-else-if="!ratios.epsgrowth") -
                                li {{ $t('ret_equity') }} 
                                    span(class="values", v-if="ratios.returnonequity") {{ ratios.returnonequity }}
                                    span(class="values", v-else-if="!ratios.returnonequity") -
                                li {{ $t('quick_ratio') }}  
                                    span(class="values", v-if="ratios.qquickrati") {{ ratios.qquickrati }}
                                    span(class="values", v-else-if="!ratios.qquickrati") -
                            div(class="fundamentals-details end-16")
                                li {{ $t('consensus') }} 
                                    span(class="values", v-if="forecast.consrecom") {{ forecast.consrecom }}
                                    span(class="values", v-else-if="!forecast.consrecom") -
                                li {{ $t('recommendation') }} 
                                    span(class="values", v-if="forecast.projltgrowthrate") {{ forecast.projltgrowthrate }}
                                    span(class="values", v-else-if="!forecast.projltgrowthrate") -
                                li {{ $t('long_term_growth_rate') }}  
                                    span(class="values", v-if="forecast.projpe") {{ forecast.projpe }}
                                    span(class="values", v-else-if="!forecast.projpe") -
                                li {{ $t('price_eps') }} 
                                    span(class="values", v-if="forecast.projsalesq") {{ forecast.projsalesq }}
                                    span(class="values", v-else-if="!forecast.projsalesq") -
                                li {{ $t('salary_quaterly') }} 
                                    span(class="values", v-if="forecast.targetprice") {{ forecast.targetprice }}
                                    span(class="values", v-else-if="!forecast.targetprice") -
                            div(class="fund-detail end-16")
                                li {{ $t('dividend') }}
                                    span(class="values", v-if="marketData[7286]") {{ marketData[7286] }}
                                    span(class="values", v-else-if="!marketData[7286]") -
                                li {{ $t('dividend_yield') }}
                                    span(class="values", v-if="marketData[7287]") {{ marketData[7287] }}
                                    span(class="values", v-else-if="!marketData[7287]") -
                                li {{ $t('ex_date') }}
                                    span(class="values", v-if="marketData[7288]") {{ marketData[7288] }}
                                    span(class="values", v-else-if="!marketData[7288]") -
</template>

<script>
import api from '../api';
import tradingChart from '../js/TradingChart.js';

export default {
    name: 'DetailsModal',
    components: {
    },
    data() {
        return {
            assetClass: '',
            type: '',
            show: false,
            results: '',
            summary: '',
            isSummary: true,
            ratios: '',
            forecast: '',
            assetName: '',
            listingExchange: '',
            iframeURL: '',
            langCookie: '',
            quoteDetailsCookieValue: '',
            quoteDetailsCookie: '',
            nightlyCookie: '',
            showQuoteDetails: '',
            loginURL: '',
            signUpTrackingURLs : [
                { domain: "com", url: "https://www.interactivebrokers.com/mkt/?src=ibkrpeqd&url=%2Fen%2Findex.php%3Ff%3D4695"},
                { domain: "sg", url: "https://www.interactivebrokers.com.sg/mkt/?src=ibkrpeqd1&url=%2Fen%2Findex.php%3Ff%3D4695"},
                { domain: "hk", url: "https://www.interactivebrokers.com.hk/mkt/?src=ibkrpeqd2&url=%2Fen%2Findex.php%3Ff%3D4695"},
                { domain: "ca", url: "https://www.interactivebrokers.ca/mkt/?src=ibkrpeqd3&url=%2Fen%2Findex.php%3Ff%3D4695"},
                { domain: "au", url: "https://www.interactivebrokers.com.au/mkt/?src=ibkrpeqd4&url=%2Fen%2Findex.php%3Ff%3D43400"},
                { domain: "uk", url: "https://www.interactivebrokers.co.uk/mkt/?src=ibkrpeqd5&url=%2Fen%2Findex.php%3Ff%3D41364"},
                { domain: "in", url: "https://www.interactivebrokers.co.in/mkt/?src=ibkrpeqd6&url=%2Fen%2Findex.php%3Ff%3D41364"},
                { domain: "ie", url: "https://www.interactivebrokers.ie/mkt/?src=ibkrpeqd7&url=%2Fen%2Findex.php%3Ff%3D41364"},
                { domain: "hu", url: "https://www.interactivebrokers.hu/mkt/?src=ibkrpeqd8&url=%2Fen%2Findex.php%3Ff%3D41364"},
            ],
            selectedTrackingUrl: '',
            selectedDomain: ''
        }
    },
    mixins: [tradingChart],
    methods: {
        open(companyHeader, conid) {
            console.log('companyHeader', companyHeader, 'conid', conid);
            this.iframeURL = '';
            this.results = companyHeader?.toUpperCase();
            this.langCookie = document.cookie.split('IB_LANG=').pop().split(';').shift();
            console.log('langCookie', this.langCookie)
            this.quoteDetailsCookieValue = document.cookie.split('IB_QD=');
            console.log('quoteDetailCookieValue', this.langCookie)
            this.quoteDetailsCookie = document.cookie.split('IB_QD=').pop().split(';').shift();

            // IB_NIGHTLY cookie is set manually. When the cookie value is 1, nightly iframe is loaded
            this.nightlyCookie = document.cookie.split('IB_NIGHTLY=').pop().split(';').shift();

            if (this.langCookie != "en") {
                this.langCookie = "en";
            }

            // Update langugage value for Chinese and Japanese
            switch(this.langCookie) {
                case 'cn':
                    this.langCookie = "zh_CN";
                    break;
                case 'jp':
                    this.langCookie = "ja";
                    break;
            }

            console.debug("IB_LANG:", this.langCookie);
            this.getSummary(companyHeader, conid);

            if (this.isWSOpen()){
                this.subscribe(conid);
            } else {
                this.startWebSocket(conid);
            }
            
            // Adding iframe to DOM
            setTimeout(() => {
                this.reloadIframe = true;
                this.show = true;
            }, 50)
        },
        showContractDetails(conid) {
            console.log('conid', conid)
            console.log(this.assetClass)
            console.log(this.type)
            if (this.type === 'COMMON' || this.type === 'ETF') {
                if (this.nightlyCookie === '1'){
                    if (this.type === 'ETF') {
                        this.iframeURL = `https://www.interactivebrokers.com/free.to.air/nightly/web1/index.html#/?conid=${conid}&sectype=ETF&lang=${this.langCookie}`;
                    } else {
                        this.iframeURL = `https://www.interactivebrokers.com/free.to.air/nightly/web1/index.html#/?conid=${conid}&sectype=STK&lang=${this.langCookie}`;
                    }
                } else {
                    if (this.type === 'ETF') {   
                        this.iframeURL = `https://www.interactivebrokers.com/free.to.air/web1/index.html#/?conid=${conid}&sectype=ETF&lang=${this.langCookie}`;
                    } else {
                        this.iframeURL = `https://www.interactivebrokers.com/free.to.air/web1/index.html#/?conid=${conid}&sectype=STK&lang=${this.langCookie}`;
                    }
                }
                console.debug("Iframe URL: ", this.iframeURL);
                if ((this.quoteDetailsCookieValue.length > 1 && this.quoteDetailsCookie === '1') || this.nightlyCookie === '1') {
                    console.debug("Iframe with contract details");
                    this.showQuoteDetails = "new";
                } else if (this.quoteDetailsCookieValue.length > 1 && this.quoteDetailsCookie === '0'){
                    console.debug("Current contract details page");
                    this.showQuoteDetails = "old";
                } else {
                    console.debug("Current contract details page");
                    this.showQuoteDetails = "old";
                }
            } else {
                console.debug("Current contract details page");
                this.showQuoteDetails = "old";
            }
        },
        getSummary(companyHeader, conid) {
            api.getSummary(conid)
                .then(res => {
                    if (!res.error) {
                        this.summary = res.summary.replace(/&amp;/g, "&");
                        this.ratios = res.ratios;
                        this.forecast = res.forecast;
                        console.log("API call successful...",);
                    } else {
                        console.log('error here', res.error, 'status', res.statusCode);
                        this.isSummary = false;
                        console.log('setsummary', this.isSummary)
                    }
                })
                .catch(error => {
                    console.error("errorCatch", error)
                    this.isSummary = false;
                    console.log('setsummary', this.isSummary)
                })
            api.getSecdefData(conid)
                .then(response => {
                    this.assetName = response.secdef[0].name;
                    this.listingExchange = response.secdef[0].listingExchange;
                    this.assetClass = response.secdef[0].assetClass;
                    this.type = response.secdef[0].type;
                    console.log('assetclass', this.assetClass, 'type', this.type);
                })
                .then(() => {
                    this.showContractDetails(conid);
                })
        },
        close() {
            this.show = false;
            this.summary = '';
            this.isSummary = true;
            this.ratios = '';
            this.forecast = '';
            this.assetName = '';
            this.listingExchange = '';
            this.reloadIframe = false;
            this.resetValues();
        },
        openDisclosure() {
            window.open("https://ibkr.info/article/2966","_blank", "width=800px, height=500px");
        }
    },
     mounted() {
        // API to get URL for user login page
        api.getLoginURL()
            .then(response => {
                this.loginURL = response.domain;
                console.debug("Login URl: ", this.loginURL);
            })
        const domainvalue = window.location.hostname.split('.').length - 1;
        this.selectedDomain = window.location.hostname.split('.')[domainvalue];
        this.selectedTrackingUrl = this.signUpTrackingURLs.filter(url => url.domain === this.selectedDomain).map(url => url.url);
        console.log(this.selectedTrackingUrl)
        window.addEventListener('message', (event) => {
            if((event.data === 'login' || event.data === 'signUp') && event.origin === "https://www.interactivebrokers.com"){
                if(event.data  === 'login'){
                    window.open(this.loginURL + "/sso/Login","_blank");
                } else if(event.data === 'signUp') {
                    window.open(this.selectedTrackingUrl,"_blank");
                }
            }
        }, false);
        this.getSummary(this.conid);
    },
}
</script>

<style lang="less">
// .header {
//     background-color: #dde4f1;
// }
.results {
    padding: 20px;
}
.search {
    width: 30%;
    float: left;
    padding: 20px;  
}
span {
    .up {
        position: relative;
        right: -8px;
        top: -6px;
        &.active-sort {
            color: #000;
        }
    }
    .down {
        position: relative;
        left: -5px;
        top: 4px;
        &.active-sort {
            color: #000;
        }
    }
}
.description {
    color: #F99999;
    cursor: pointer;
}
.external-icon {
    svg {
        position: relative;
        top: 0.8px;
        left: 6px;
        width: 1em;
        height: 1em;
    }
}
.icon-close {
    position: absolute;
    right: 10px;
    top: 10px;
    svg {
        width: 2rem;
    }
}
.contract-details {
    width: 100%;
    //border-top: 1px solid #d4d4d4;
    margin-top: 10px;
}
.iframe-headers {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-top: 16px;
}
.iframe-header-info {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.quote-details {
    // padding: 0px 10px 10px;
    color: black;
}
.quote-details-headers {
    border-bottom: 1px solid #d4d4d4;
    display: flex;
}
.quote-askbid {
    display: flex;
    padding-left: 28px;
    padding-top: 24px;
}
.symprice {
    padding-left: 16px;
}
.ask-bid {
    font-size: 16px;
}
.ask-bid-data {
    padding-left: 15px;
}
.quote-details-data {
    margin-left: 8px;
    font-size: 22px;
}
.summary {
    text-align: left;
    color: black;
    padding: 16px;
    border-bottom: 1px solid #d4d4d4;
}
.fundamentals-details {
    align-self: stretch;
}

.fundamentals-details li {
    list-style: none;
}
.fund-detail {
    align-self: stretch;
}
.fund-detail li {
    list-style: none;
}
.marketadata-col {
    border-right: 1px solid #d4d4d4;
}
.md-col {
    align-self: stretch;
    padding: 6px;
}
.values {
    float: right;
    font-weight: bold;
}
.comp-dialog {
    border-top: 5px solid #d91222
}
@media (max-width:768px) {
    .header-info {
        display: flex;
        flex-direction: column;
    }
    .product-name {
        width: 100%;
        padding-right: 20px;
    }
    .disclose {
        width: 100%;
        text-align: left;
    }
    .fundamentals {
        color:black;
        flex-direction: column;
        padding-top: 24px;
    }
    .fundamentals-details {
        padding-left: 16px;
    }
    .fund-detail {
        padding-left: 16px;
    }
}
@media (min-width:768px) {
    .header-info {
        display: flex;
        flex-direction: row;
    }
    .product-name {
        width: 40%;
        box-sizing: border-box;
        padding-right: 20px;
    }
    .disclose {
        width: 55%;
        height: 90%;
        text-align: left;
    }
    .fundamentals {
        color:black;
        flex-direction: row;
        padding-top: 24px;
    }
    .fundamentals-details {
        border-right: 1px solid #d4d4d4;
        margin-right: 20px;
    }
}
.disclose-link {
    color: blue;
    cursor: pointer;
}
.alignment {
    position: relative;
    left: 50%;//
}
</style>